import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-392d3635"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "temp",
  temp: "b"
}
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "detail-item" }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "detail-item" }
const _hoisted_7 = { class: "detail-item" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "detail-item"
}
const _hoisted_11 = { class: "detail-item" }
const _hoisted_12 = { class: "detail-item" }
const _hoisted_13 = { class: "detail-item" }
const _hoisted_14 = { class: "table" }
const _hoisted_15 = { class: "table-thead" }
const _hoisted_16 = { class: "table-body" }
const _hoisted_17 = ["src"]

import { t } from '@/plugins/i18n'
import { ref, reactive } from 'vue'
import { getJapanTime } from '@/util/common'
import { formatPrice, plusPrice, reducePrice } from './data'
import { showCurrentUnit } from '@/util/useYan'
import { isMultiStore } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowName: {
    type: String,
    default: ''
  },
  rowItemDetail: {
    type: Object,
    default: () => ({})
  }
},
  setup(__props) {



const columns = [
  { prop: 'productImg', label: t('商品图片') },
  { prop: 'productSku', label: t('平台商品SKU') },
  { prop: 'customerProductSku', label: t('客户商品SKU') },
  { prop: 'productPropertiesName', label: t('规格') },
  // { prop: 'productTitle', label: t('商品信息') },
  { prop: 'settlePrice', label: t('销售单价') },
  { prop: 'num', label: t('结算数量') },
  { prop: 'settleMoney', label: t('结算总价') }
]

return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, { height: "500px" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('费用类型')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowName), 1)
          ]),
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('可用余额')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(formatPrice)(__props.rowItemDetail.customerWalletFundFlowOrderDTO?.afterAvailableAmount)) + _toDisplayString(_unref(showCurrentUnit)(_unref(isMultiStore)() && __props.rowItemDetail?.currencyCode === 'KRW')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('THE CKB订单编号')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.platformOrderNo ?? ''), 1)
          ]),
          _createElementVNode("p", _hoisted_7, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('客户订单编号')) + "：", 1),
            (__props.rowItemDetail?.customerOrderNo)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(__props.rowItemDetail?.customerOrderNo), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(__props.rowItemDetail?.customerBill?.customerOrderNo ?? '-'), 1))
          ]),
          (__props.rowItemDetail.fundFlowNo)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(_unref(t)('流水号')) + "：", 1),
                _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.fundFlowNo), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_11, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('日期')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(getJapanTime)(__props.rowItemDetail.customerWalletFundFlowOrderDTO?.createTime)), 1)
          ]),
          _createElementVNode("p", _hoisted_12, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('结算总数量')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail?.customerWalletFundFlowOrderDTO?.num ?? 0), 1)
          ]),
          _createElementVNode("p", _hoisted_13, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('结算总价')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(reducePrice)(__props.rowItemDetail?.customerWalletFundFlowOrderDTO?.money ?? 0)) + _toDisplayString(_unref(showCurrentUnit)(_unref(isMultiStore)() && __props.rowItemDetail?.currencyCode === 'KRW')), 1)
          ])
        ]),
        _createElementVNode("table", _hoisted_14, [
          _createElementVNode("thead", _hoisted_15, [
            _createElementVNode("tr", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (item) => {
                return _createElementVNode("th", {
                  key: item.prop,
                  width: "157"
                }, _toDisplayString(item.label), 1)
              }), 64))
            ])
          ]),
          _createElementVNode("tbody", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((__props.rowItemDetail.customerWalletFundFlowOrderDTO?.customerWalletFundFlowGoodsDTOList || []), (row) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: row.productSku
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (v) => {
                  return _createElementVNode("td", {
                    key: v.prop
                  }, [
                    (v.prop === 'productPropertiesName')
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList((row[v.prop] || '').split(';'), (prop) => {
                          return (_openBlock(), _createElementBlock("p", { key: prop }, _toDisplayString(prop.replace(/[+-]?\d+:[+-]?\d+:/, '')), 1))
                        }), 128))
                      : (v.prop === 'productImg')
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            referrerPolicy: "no-referrer",
                            src: row[v.prop],
                            alt: "",
                            style: {"width":"60px"}
                          }, null, 8, _hoisted_17))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(row[v.prop]), 1)
                          ], 64))
                  ])
                }), 64))
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})